<template>
  <div>
    <h4>Артикл Artikel</h4>

    <h6 class="fontbold">1. Склонение определённых артиклей</h6>

    <div class="row">
      <div class="col s12 m8 l6">
        <table>
          <tbody>
            <tr>
              <td></td>
              <td>ед.ч. муж.р.</td>
              <td>ед.ч. жен.р.</td>
              <td>ед.ч. сред.р.</td>
              <td>множ.ч.</td>
            </tr>

            <tr>
              <td>Nom.</td>
              <td>der</td>
              <td>die</td>
              <td>das</td>
              <td>die</td>
            </tr>

            <tr>
              <td>Akk.</td>
              <td>den</td>
              <td>die</td>
              <td>das</td>
              <td>die</td>
            </tr>

            <tr>
              <td>Dat.</td>
              <td>dem</td>
              <td>der</td>
              <td>dem</td>
              <td>den</td>
            </tr>

            <tr>
              <td>Gen.</td>
              <td>des</td>
              <td>der</td>
              <td>des</td>
              <td>der</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 class="fontbold">2. Склонение неопределённых артиклей</h6>

    <div class="row">
      <div class="col s12 m8 l6">
        <table>
          <tbody>
            <tr>
              <td></td>
              <td>ед.ч. муж.р.</td>
              <td>ед.ч. жен.р.</td>
              <td>ед.ч. сред.р.</td>
              <td>множ.ч.</td>
            </tr>

            <tr>
              <td>Nom.</td>
              <td>ein</td>
              <td>eine</td>
              <td>ein</td>
              <td>-</td>
            </tr>

            <tr>
              <td>Akk.</td>
              <td>einen</td>
              <td>eine</td>
              <td>ein</td>
              <td>-</td>
            </tr>

            <tr>
              <td>Dat.</td>
              <td>einem</td>
              <td>einer</td>
              <td>einem</td>
              <td>-</td>
            </tr>

            <tr>
              <td>Gen.</td>
              <td>eines</td>
              <td>einer</td>
              <td>eines</td>
              <td>-</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <p>Вместо артикля могут стоять другие слова, например местоимения. Они называются слова-спутники.</p>
    <blockquote>dieses Brot, jenes Brot, kein Brot, mein Brot</blockquote>

    <p>
      "Kein" как слово-спутник имеет точно такие же формы как "ein". 
      Различаются только формы множественного числа.
    </p>
    <div class="row">
      <div class="col s12 m8 l6">
        <table>
          <tbody>
            <tr>
              <td>Nom.</td>
              <td>Akk.</td>
              <td>Dat.</td>
              <td>Gen.</td>
            </tr>

            <tr>
              <td>keine</td>
              <td>keine</td>
              <td>keinen</td>
              <td>keiner</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>


<style scoped>
.fontbold {
  font-weight: bold;
}
td {
  padding: 2px 2px;
}
</style>


<script>
export default {
  name: "grammatik_artikel",
  data: () => ({}),
  computed: {}
};
</script>
